"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBaseSampleRate = void 0;
const TRACE_SAMPLE_RATE = 0.000001;
function getBaseSampleRate() {
    return TRACE_SAMPLE_RATE;
}
exports.getBaseSampleRate = getBaseSampleRate;
//# sourceMappingURL=getBaseSampleRate.web.js.map